import { Injectable, ViewContainerRef, inject } from '@angular/core';
import { Router } from '@angular/router';

import { ApiService } from './api.service';
import { DialogService } from './dialog.service';
import { FeedbackDialogComponent } from '../../products/components/feedback-dialog/feedback-dialog.component';

export interface Feedback {
  type: string;
  content: string;
  contact: boolean;
  pageName: string;
}

@Injectable({
  providedIn: 'root'
})
export class FeedbackService {
  private apiService = inject(ApiService);
  private dialogService = inject(DialogService);
  private router = inject(Router);

  onFeedback(container?: ViewContainerRef) {
    if (container) {
      this.dialogService.show(container, FeedbackDialogComponent).subscribe(dialogResult => {
        if (dialogResult.isSubmitted) {
          const model = dialogResult.value as Feedback;
          model.pageName = this.router.url;
          this.apiService.post<void>('api/feedback', model).subscribe();
        }
      });
    }
  }
}
